import script from "./VillageSurveyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VillageSurveyModal.vue?vue&type=script&setup=true&lang=js"

import "./VillageSurveyModal.vue?vue&type=style&index=0&id=fad3d314&lang=css"

const __exports__ = script;

export default __exports__